export default "../../src/img/homey.png";